import styled from "styled-components"



export const StyledMAinDiv = styled.div.attrs(() => ({
    className: "d-flex flex-wrap"
}))`

`

export const StyledDiv = styled.div.attrs(() => ({
    className: "d-flex flex-wrap pl-4"
}))`

`